import { Component, ojs, app } from "modular-openscriptjs";
import { cleanDispose } from "../../helpers";
import { tool } from "../../fotastart";
import { acceptAppReviewPrompt, snoozeAppReviewPrompt } from "../../reviewPrompt";

const h = app("h");
const $e = app("$e");

export default class AppReviewPromptModal extends Component {
    modal = null;
    handled = false;

    render(...args) {
        return h.div({ class: "d-none" }, ...args);
    }

    showForm() {
        if (this.modal) {
            cleanDispose(this.modal);
        }

        this.handled = false;

        let content = h.div(
            {
                class: "modal-content border-0 shadow-lg rounded-4 overflow-hidden",
            },
            h.div(
                { class: "modal-body p-4 text-center" },
                h.div(
                    { class: "mb-3" },
                    h.i({
                        class: "fa-solid fa-heart text-danger",
                        style: "font-size: 2.5rem;",
                    }),
                ),
                h.h5({ class: "fw-bold mb-2" }, "Enjoying Carata?"),
                h.p(
                    { class: "text-muted mb-0" },
                    "You've been running your business on Carata for a while now. Mind sharing your experience with a quick rating on the Play Store?",
                ),
            ),
            h.div(
                {
                    class: "modal-footer border-0 px-4 pb-4 pt-0 d-flex flex-column gap-2",
                },
                h.button(
                    {
                        class: "btn btn-primary rounded-pill w-100 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2",
                        onclick: this.method("rateNow"),
                    },
                    h.i({ class: "fas fa-star" }),
                    "Rate Carata",
                ),
                h.button(
                    {
                        class: "btn btn-light rounded-pill w-100 fw-semibold",
                        onclick: this.method("remindLater"),
                    },
                    "Maybe Later",
                ),
            ),
        );

        this.modal = tool.plainModal(content, {});

        // Treat any dismissal (backdrop click, ESC, swipe) as "maybe later"
        // unless one of the buttons already recorded a response.
        this.modal._element?.addEventListener("hidden.bs.modal", () => {
            if (!this.handled) {
                this.handled = true;
                snoozeAppReviewPrompt();
            }
        });

        this.modal.show();
    }

    async rateNow() {
        this.handled = true;
        this.modal?.hide();
        await acceptAppReviewPrompt();
    }

    async remindLater() {
        this.handled = true;
        this.modal?.hide();
        await snoozeAppReviewPrompt();
    }

    $$appReview = {
        needs: {
            prompt: () => this.showForm(),
        },
    };

    cleanUp() {
        super.cleanUp();
        if (this.modal) cleanDispose(this.modal);
    }
}

ojs(AppReviewPromptModal);
